<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.editArea") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #008274">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
            <ValidationObserver v-slot="{ invalid, validate }">

  <form @submit.prevent="validate().then((valid) => valid && validateFormInputs())">
      
        <div class="row">
          <!-- Start:: Name AR Input -->
          <ValidationProvider
            :name="$t('PLACEHOLDERS.nameAr')"
            rules="required"
            v-slot="{ errors }"
            class="col-lg-6"
          >
            <base-input
              col="12"
              type="text"
              :placeholder="$t('PLACEHOLDERS.nameAr')"
              v-model.trim="data.name_ar"
              @input="data.name_ar = allowArabicNumbersSymbols($event)"
              :errors="errors[0]"
              required
            />
          </ValidationProvider>

          <!-- Start:: Name EN Input -->
          <ValidationProvider
            :name="$t('PLACEHOLDERS.nameEn')"
            rules="required"
            v-slot="{ errors }"
            class="col-lg-6"
          >
            <base-input
              col="12"
              type="text"
              :placeholder="$t('PLACEHOLDERS.nameEn')"
              v-model.trim="data.name_en"
              @input="data.name_en = allowEnglishNumbersSymbols($event)"
              :errors="errors[0]"
              required
            />
          </ValidationProvider>

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper col-12 text-end">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="invalid || isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </ValidationObserver >

    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import allowLanguageMinxin from "@/mixins/allowLanguageMinxins.js";

export default {
  name: "EditState",
  mixins: [allowLanguageMinxin],

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        name_ar: null,
        name_en: null,
        active: null,
      },

      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      if (!this.data.name_ar) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name_ar"));
        return;
      } else if (!this.data.name_en) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name_en"));
        return;
      } else {
        this.submitForm();
      }
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data

      if (this.data.name_ar) {
        REQUEST_DATA.append("name[ar]", this.data.name_ar);
      }
      if (this.data.name_en) {
        REQUEST_DATA.append("name[en]", this.data.name_en);
      }
      REQUEST_DATA.append("_method", "PUT");
      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);
      try {
        await this.$axios({
          method: "POST",
          url: `states/${this.$route.params?.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/states/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },

    // start show data
    async showState() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `states/${this.$route.params?.id}`,
        });
        this.data.name_ar = res.data.data.State.trans?.name?.ar;
        this.data.name_en = res.data.data.State.trans?.name?.en;
        this.data.active = res.data.data.State.is_active ? 1 : 0;
      } catch (error) {
        this.loading = false;
        console.log(error?.response?.data?.message);
      }
    },
    // end show data
  },

  created() {
    this.showState();
  },
};
</script>
